import React, { FC } from 'react';
import {
  OParagraph,
  Flex,
  InfoCircleOIcon,
  defaultColors,
  ProgressBar,
} from '@lifechurch/react-ion';
import styled from 'styled-components';
import ChecklistItem, { OnboardingStepKeys } from './ChecklistItems/ChecklistItem';
import { OnboardingStep } from '@generated/types';
import { useTranslation } from 'react-i18next';

export interface Props {
  testId: string;
  onboardingSteps: OnboardingStep[];
  skipOnboardingStep: (stepId: string) => void;
}

const Wrapper = styled.div`
  padding-bottom: 8px;
`;

const ProgressWrapper = styled.div`
  padding: 4px 8px;
`;

const ChecklistInProgress: FC<Props> = ({ onboardingSteps, skipOnboardingStep, testId }) => {
  const percentComplete =
    (onboardingSteps.filter(step => step.completed || step.skipped).length /
      onboardingSteps.length) *
    100;
  const { t } = useTranslation('common');

  const getText: (step: OnboardingStep) => string = step => {
    switch (step.key) {
      case OnboardingStepKeys.SERVICE:
        return t('add_a_service_time');
      case OnboardingStepKeys.CONTENT:
        return t('add_content_to_a_service');
      case OnboardingStepKeys.CUSTOMIZE:
        return t('customize_your_site');
      case OnboardingStepKeys.INVITE:
        return t('invite_your_team');
      default:
        return '';
    }
  };

  const getLink: (step: OnboardingStep) => string = step => {
    switch (step.key) {
      case OnboardingStepKeys.SERVICE:
        return '/services';
      case OnboardingStepKeys.CONTENT:
        return '/services';
      case OnboardingStepKeys.CUSTOMIZE:
        return '/setup/appearance';
      case OnboardingStepKeys.INVITE:
        return '/users';
      default:
        return '';
    }
  };

  return (
    <Wrapper data-testid={testId}>
      <Flex marginInlineStart={'3'}>
        {<InfoCircleOIcon />}
        <OParagraph color={defaultColors.gray100} marginInlineStart={2}>
          {t('first_steps')}
        </OParagraph>
      </Flex>
      <ProgressWrapper>
        <ProgressBar percentComplete={percentComplete} />
      </ProgressWrapper>
      {onboardingSteps.map(step => (
        <ChecklistItem
          key={step.id}
          link={getLink(step)}
          onSkip={() => skipOnboardingStep(step.id)}
          onboardingStep={step}
          text={getText(step)}
        />
      ))}
    </Wrapper>
  );
};

export default ChecklistInProgress;
